const ProductTabs = ({ tabs = [], activeTab = 0, onTabChange, children }) => {
  const handleTabClick = (index, tab) => {
    // Maintain tracking/埋点
    if (tab.onClick) {
      tab.onClick();
    }
    onTabChange(index);
  };

  return (
    <div className="mt-5 bg-white">
      {/* 综合产品 - Tab Headers */}
      <div className="bg-white mt-5 border-b-2 border-solid border-[#0094e7]" data-spm="tab">
        <div className="overflow-hidden">
          {tabs.map((tab, index) => (
            <a
              key={tab.key}
              data-spm={tab.spm || index + 1}
              href={tab.href || '#'}
              target={tab.target || '_parent'}
              onClick={(e) => {
                if (!tab.href || tab.href === '#') {
                  e.preventDefault();
                }
                handleTabClick(index, tab);
              }}
              className={`
              float-left px-5 h-[50px] leading-[50px] mr-0.5 relative
              border border-gray-300 border-b-2 border-b-gray-300
              transition-all duration-300
              ${
                activeTab === index
                  ? 'bg-white text-[#0094e7] border-[#0094e7] border-b-white -mb-0.5 font-medium'
                  : 'bg-[#f5f5f5] text-gray-600 hover:bg-[#e6f7ff] hover:text-[#0094e7]'
              }
              ${tab.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
            `}
              style={tab.disabled ? { color: '#999' } : {}}
            >
              {/* Shopping Cart Icon */}
              {tab.icon === 'shouppingCar_icon' && (
                <i
                  className="float-left w-4 h-4 mr-1"
                  style={{
                    backgroundImage:
                      'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/shouppingCar_icon.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    marginTop: '17px',
                  }}
                />
              )}

              {/* Gift Icon */}
              {tab.icon === 'gift_icon' && (
                <i
                  className="float-left w-4 h-4 mr-1"
                  style={{
                    backgroundImage:
                      'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/gift_icon.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    marginTop: '17px',
                  }}
                />
              )}

              <span className={tab.icon ? 'float-left text-[16px]' : 'text-[16px]'}>{tab.label}</span>
              {/* Active tab triangle indicator */}
              {activeTab === index && (
                <i
                  className="absolute left-1/2 -ml-2.5"
                  style={{
                    bottom: '-2px',
                    width: 0,
                    height: 0,
                    borderBottom: '10px solid #0094e7',
                    borderTop: '10px solid transparent',
                    borderLeft: '10px solid transparent',
                    borderRight: '10px solid transparent',
                  }}
                />
              )}

              {tab.icon && <span className="clear-both" />}
            </a>
          ))}
          <div className="clear-both" />
        </div>
      </div>

      {/* Tab Content */}
      <div className="bg-white">
        <div className="min-h-[400px]">
          <div className="pb-[30px] box-border">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ProductTabs;
